import React from 'react'

const Scaner = props => (
  <svg
    id="prefix__Warstwa_1"
    x={0}
    y={0}
    viewBox="0 0 1920 1080"
    xmlSpace="preserve"
  >
    <style>
      {
        '.mainprefix__st0{fill:#00b423}.mainprefix__st1{fill:#ccc}.mainprefix__st2{fill:#666}.mainprefix__st3{fill:gray}.mainprefix__st4{fill:#0f0}.mainprefix__st5{fill:#c1272d}.mainprefix__st6{fill:#ff0}.mainprefix__st7{fill:#fff}.mainprefix__st8{fill:#f7931e}.mainprefix__st9{fill:#29abe2}.mainprefix__st10{fill:#4d4d4d}.mainprefix__st11{fill:#ed1c24}'
      }
    </style>
    <path
      className="mainprefix__st0"
      d="M376.8 512c-4.9 0-8.8-3.9-8.8-8.8V157.8c0-4.8 4-8.8 8.8-8.8h346.3c4.9 0 8.8 3.9 8.8 8.8v345.4c0 4.8-4 8.8-8.8 8.8H376.8z"
    />
    <path d="M722 159v343H378V159h344m1.2-20H376.8c-10.4 0-18.8 8.4-18.8 18.8v345.4c0 10.4 8.4 18.8 18.8 18.8h346.3c10.4 0 18.8-8.4 18.8-18.8V157.8c.1-10.4-8.3-18.8-18.7-18.8z" />
    <path className="mainprefix__st1" d="M432 532h236v427H432z" />
    <path d="M658 542v407H442V542h216m20-20H422v447h256V522z" />
    <path className="mainprefix__st2" d="M395.3 528.8l36.4-4.3-11.8 34.7z" />
    <path d="M417.1 536.3l-.9 2.5-1.8-2.2 2.7-.3m29.2-23.6l-70.2 8.3 47.5 58.6 22.7-66.9z" />
    <path className="mainprefix__st2" d="M669.7 516.5l36.4 4.3-24.7 30.4z" />
    <path d="M684.2 528.3l2.7.3-1.8 2.2-.9-2.5m-29.1-23.6l22.7 66.9 47.5-58.6-70.2-8.3z" />
    <path
      className="mainprefix__st3"
      d="M460 591.8c-2.4 0-5-6.2-5-14.4s2.6-14.4 5-14.4h28c2.4 0 5 6.2 5 14.4s-2.6 14.4-5 14.4h-28z"
    />
    <path
      className="mainprefix__st4"
      d="M488 564c1.2 0 4 4.7 4 13.4s-2.8 13.4-4 13.4h-28c-1.2 0-4-4.7-4-13.4s2.8-13.4 4-13.4h28m0-2h-28c-3.3 0-6 6.9-6 15.4s2.7 15.4 6 15.4h28c3.3 0 6-6.9 6-15.4s-2.7-15.4-6-15.4z"
    />
    <path
      className="mainprefix__st3"
      d="M612 591.8c-2.4 0-5-6.2-5-14.4s2.6-14.4 5-14.4h28c2.4 0 5 6.2 5 14.4s-2.6 14.4-5 14.4h-28z"
    />
    <path
      className="mainprefix__st5"
      d="M640 564c1.2 0 4 4.7 4 13.4s-2.8 13.4-4 13.4h-28c-1.2 0-4-4.7-4-13.4s2.8-13.4 4-13.4h28m0-2h-28c-3.3 0-6 6.9-6 15.4s2.7 15.4 6 15.4h28c3.3 0 6-6.9 6-15.4s-2.7-15.4-6-15.4z"
    />
    <path
      className="mainprefix__st6"
      d="M590 577.4c0 8.5-5.4 15.4-12 15.4h-56c-6.6 0-12-6.9-12-15.4s5.4-15.4 12-15.4h56c6.6 0 12 6.9 12 15.4z"
    />
    <path
      className="mainprefix__st7"
      d="M460 628c-3.2 0-5.8-5.4-5.8-12.1s2.6-12.1 5.8-12.1h28c3.2 0 5.8 5.4 5.8 12.1S491.2 628 488 628h-28z"
    />
    <path d="M488 604.1c3 0 5.5 5.4 5.5 11.8s-2.5 11.8-5.5 11.8h-28c-3 0-5.5-5.4-5.5-11.8s2.5-11.8 5.5-11.8h28m0-.5h-28c-3.3 0-6 5.5-6 12.3 0 6.8 2.7 12.3 6 12.3h28c3.3 0 6-5.5 6-12.3 0-6.8-2.7-12.3-6-12.3z" />
    <path
      className="mainprefix__st7"
      d="M510 628c-3.2 0-5.8-5.4-5.8-12.1s2.6-12.1 5.8-12.1h28c3.2 0 5.8 5.4 5.8 12.1S541.2 628 538 628h-28z"
    />
    <path d="M538 604.1c3 0 5.5 5.4 5.5 11.8s-2.5 11.8-5.5 11.8h-28c-3 0-5.5-5.4-5.5-11.8s2.5-11.8 5.5-11.8h28m0-.5h-28c-3.3 0-6 5.5-6 12.3 0 6.8 2.7 12.3 6 12.3h28c3.3 0 6-5.5 6-12.3 0-6.8-2.7-12.3-6-12.3z" />
    <path
      className="mainprefix__st7"
      d="M562 628c-3.2 0-5.8-5.4-5.8-12.1s2.6-12.1 5.8-12.1h28c3.2 0 5.8 5.4 5.8 12.1S593.2 628 590 628h-28z"
    />
    <path d="M590 604.1c3 0 5.5 5.4 5.5 11.8s-2.5 11.8-5.5 11.8h-28c-3 0-5.5-5.4-5.5-11.8s2.5-11.8 5.5-11.8h28m0-.5h-28c-3.3 0-6 5.5-6 12.3 0 6.8 2.7 12.3 6 12.3h28c3.3 0 6-5.5 6-12.3 0-6.8-2.7-12.3-6-12.3z" />
    <path
      className="mainprefix__st7"
      d="M612 628c-3.2 0-5.8-5.4-5.8-12.1s2.6-12.1 5.8-12.1h28c3.2 0 5.8 5.4 5.8 12.1S643.2 628 640 628h-28z"
    />
    <path d="M640 604.1c3 0 5.5 5.4 5.5 11.8s-2.5 11.8-5.5 11.8h-28c-3 0-5.5-5.4-5.5-11.8s2.5-11.8 5.5-11.8h28m0-.5h-28c-3.3 0-6 5.5-6 12.3 0 6.8 2.7 12.3 6 12.3h28c3.3 0 6-5.5 6-12.3 0-6.8-2.7-12.3-6-12.3z" />
    <path
      className="mainprefix__st7"
      d="M510 703.5c-3.1 0-5.8-6.9-5.8-15.2 0-8.2 2.6-15.2 5.8-15.2h28c3.1 0 5.8 6.9 5.8 15.2 0 8.2-2.6 15.2-5.8 15.2h-28z"
    />
    <path d="M538 673.5c2.7 0 5.5 6 5.5 14.9s-2.8 14.9-5.5 14.9h-28c-2.7 0-5.5-6-5.5-14.9s2.8-14.9 5.5-14.9h28m0-.5h-28c-3.3 0-6 6.9-6 15.4s2.7 15.4 6 15.4h28c3.3 0 6-6.9 6-15.4s-2.7-15.4-6-15.4z" />
    <path
      className="mainprefix__st7"
      d="M562 703.5c-3.1 0-5.8-6.9-5.8-15.2 0-8.2 2.6-15.2 5.8-15.2h28c3.1 0 5.8 6.9 5.8 15.2 0 8.2-2.6 15.2-5.8 15.2h-28z"
    />
    <path d="M590 673.5c2.7 0 5.5 6 5.5 14.9s-2.8 14.9-5.5 14.9h-28c-2.7 0-5.5-6-5.5-14.9s2.8-14.9 5.5-14.9h28m0-.5h-28c-3.3 0-6 6.9-6 15.4s2.7 15.4 6 15.4h28c3.3 0 6-6.9 6-15.4s-2.7-15.4-6-15.4z" />
    <path
      className="mainprefix__st3"
      d="M612 703.5c-3.1 0-5.8-6.9-5.8-15.2 0-8.2 2.6-15.2 5.8-15.2h28c3.1 0 5.8 6.9 5.8 15.2 0 8.2-2.6 15.2-5.8 15.2h-28z"
    />
    <path d="M640 673.5c2.7 0 5.5 6 5.5 14.9s-2.8 14.9-5.5 14.9h-28c-2.7 0-5.5-6-5.5-14.9s2.8-14.9 5.5-14.9h28m0-.5h-28c-3.3 0-6 6.9-6 15.4s2.7 15.4 6 15.4h28c3.3 0 6-6.9 6-15.4s-2.7-15.4-6-15.4z" />
    <path
      className="mainprefix__st7"
      d="M460 746.7c-3.1 0-5.8-6.9-5.8-15.2 0-8.2 2.6-15.2 5.8-15.2h28c3.1 0 5.8 6.9 5.8 15.2 0 8.2-2.6 15.2-5.8 15.2h-28z"
    />
    <path d="M488 716.6c2.7 0 5.5 6 5.5 14.9s-2.8 14.9-5.5 14.9h-28c-2.7 0-5.5-6-5.5-14.9s2.8-14.9 5.5-14.9h28m0-.5h-28c-3.3 0-6 6.9-6 15.4s2.7 15.4 6 15.4h28c3.3 0 6-6.9 6-15.4s-2.7-15.4-6-15.4z" />
    <path
      className="mainprefix__st7"
      d="M510 746.7c-3.1 0-5.8-6.9-5.8-15.2 0-8.2 2.6-15.2 5.8-15.2h28c3.1 0 5.8 6.9 5.8 15.2 0 8.2-2.6 15.2-5.8 15.2h-28z"
    />
    <path d="M538 716.6c2.7 0 5.5 6 5.5 14.9s-2.8 14.9-5.5 14.9h-28c-2.7 0-5.5-6-5.5-14.9s2.8-14.9 5.5-14.9h28m0-.5h-28c-3.3 0-6 6.9-6 15.4s2.7 15.4 6 15.4h28c3.3 0 6-6.9 6-15.4s-2.7-15.4-6-15.4z" />
    <path
      className="mainprefix__st7"
      d="M562 746.7c-3.1 0-5.8-6.9-5.8-15.2 0-8.2 2.6-15.2 5.8-15.2h28c3.1 0 5.8 6.9 5.8 15.2 0 8.2-2.6 15.2-5.8 15.2h-28z"
    />
    <path d="M590 716.6c2.7 0 5.5 6 5.5 14.9s-2.8 14.9-5.5 14.9h-28c-2.7 0-5.5-6-5.5-14.9s2.8-14.9 5.5-14.9h28m0-.5h-28c-3.3 0-6 6.9-6 15.4s2.7 15.4 6 15.4h28c3.3 0 6-6.9 6-15.4s-2.7-15.4-6-15.4z" />
    <path
      className="mainprefix__st3"
      d="M612 746.7c-3.1 0-5.8-6.9-5.8-15.2 0-8.2 2.6-15.2 5.8-15.2h28c3.1 0 5.8 6.9 5.8 15.2 0 8.2-2.6 15.2-5.8 15.2h-28z"
    />
    <path d="M640 716.6c2.7 0 5.5 6 5.5 14.9s-2.8 14.9-5.5 14.9h-28c-2.7 0-5.5-6-5.5-14.9s2.8-14.9 5.5-14.9h28m0-.5h-28c-3.3 0-6 6.9-6 15.4s2.7 15.4 6 15.4h28c3.3 0 6-6.9 6-15.4s-2.7-15.4-6-15.4z" />
    <path
      className="mainprefix__st7"
      d="M460 789.8c-3.1 0-5.8-6.9-5.8-15.2 0-8.2 2.6-15.2 5.8-15.2h28c3.1 0 5.8 6.9 5.8 15.2 0 8.2-2.6 15.2-5.8 15.2h-28z"
    />
    <path d="M488 759.7c2.7 0 5.5 6 5.5 14.9s-2.8 14.9-5.5 14.9h-28c-2.7 0-5.5-6-5.5-14.9s2.8-14.9 5.5-14.9h28m0-.5h-28c-3.3 0-6 6.9-6 15.4s2.7 15.4 6 15.4h28c3.3 0 6-6.9 6-15.4s-2.7-15.4-6-15.4z" />
    <path
      className="mainprefix__st7"
      d="M510 789.8c-3.1 0-5.8-6.9-5.8-15.2 0-8.2 2.6-15.2 5.8-15.2h28c3.1 0 5.8 6.9 5.8 15.2 0 8.2-2.6 15.2-5.8 15.2h-28z"
    />
    <path d="M538 759.7c2.7 0 5.5 6 5.5 14.9s-2.8 14.9-5.5 14.9h-28c-2.7 0-5.5-6-5.5-14.9s2.8-14.9 5.5-14.9h28m0-.5h-28c-3.3 0-6 6.9-6 15.4s2.7 15.4 6 15.4h28c3.3 0 6-6.9 6-15.4s-2.7-15.4-6-15.4z" />
    <path
      className="mainprefix__st7"
      d="M562 789.8c-3.1 0-5.8-6.9-5.8-15.2 0-8.2 2.6-15.2 5.8-15.2h28c3.1 0 5.8 6.9 5.8 15.2 0 8.2-2.6 15.2-5.8 15.2h-28z"
    />
    <path d="M590 759.7c2.7 0 5.5 6 5.5 14.9s-2.8 14.9-5.5 14.9h-28c-2.7 0-5.5-6-5.5-14.9s2.8-14.9 5.5-14.9h28m0-.5h-28c-3.3 0-6 6.9-6 15.4s2.7 15.4 6 15.4h28c3.3 0 6-6.9 6-15.4s-2.7-15.4-6-15.4z" />
    <path
      className="mainprefix__st8"
      d="M460 661.9c-3.2 0-5.8-5.4-5.8-12.1s2.6-12.1 5.8-12.1h28c3.2 0 5.8 5.4 5.8 12.1s-2.6 12.1-5.8 12.1h-28z"
    />
    <path d="M488 638c3 0 5.5 5.4 5.5 11.8s-2.5 11.8-5.5 11.8h-28c-3 0-5.5-5.4-5.5-11.8S457 638 460 638h28m0-.5h-28c-3.3 0-6 5.5-6 12.3 0 6.8 2.7 12.3 6 12.3h28c3.3 0 6-5.5 6-12.3 0-6.8-2.7-12.3-6-12.3z" />
    <path
      className="mainprefix__st3"
      d="M510 661.9c-3.2 0-5.8-5.4-5.8-12.1s2.6-12.1 5.8-12.1h28c3.2 0 5.8 5.4 5.8 12.1s-2.6 12.1-5.8 12.1h-28z"
    />
    <path d="M538 638c3 0 5.5 5.4 5.5 11.8s-2.5 11.8-5.5 11.8h-28c-3 0-5.5-5.4-5.5-11.8S507 638 510 638h28m0-.5h-28c-3.3 0-6 5.5-6 12.3 0 6.8 2.7 12.3 6 12.3h28c3.3 0 6-5.5 6-12.3 0-6.8-2.7-12.3-6-12.3z" />
    <path
      className="mainprefix__st3"
      d="M562 661.9c-3.2 0-5.8-5.4-5.8-12.1s2.6-12.1 5.8-12.1h28c3.2 0 5.8 5.4 5.8 12.1s-2.6 12.1-5.8 12.1h-28z"
    />
    <path d="M590 638c3 0 5.5 5.4 5.5 11.8s-2.5 11.8-5.5 11.8h-28c-3 0-5.5-5.4-5.5-11.8S559 638 562 638h28m0-.5h-28c-3.3 0-6 5.5-6 12.3 0 6.8 2.7 12.3 6 12.3h28c3.3 0 6-5.5 6-12.3 0-6.8-2.7-12.3-6-12.3z" />
    <path
      className="mainprefix__st9"
      d="M612 661.9c-3.2 0-5.8-5.4-5.8-12.1s2.6-12.1 5.8-12.1h28c3.2 0 5.8 5.4 5.8 12.1s-2.6 12.1-5.8 12.1h-28z"
    />
    <path d="M640 638c3 0 5.5 5.4 5.5 11.8s-2.5 11.8-5.5 11.8h-28c-3 0-5.5-5.4-5.5-11.8S609 638 612 638h28m0-.5h-28c-3.3 0-6 5.5-6 12.3 0 6.8 2.7 12.3 6 12.3h28c3.3 0 6-5.5 6-12.3 0-6.8-2.7-12.3-6-12.3z" />
    <g>
      <path
        className="mainprefix__st7"
        d="M460 833c-3.1 0-5.8-6.9-5.8-15.2 0-8.2 2.6-15.2 5.8-15.2h28c3.1 0 5.8 6.9 5.8 15.2 0 8.2-2.6 15.2-5.8 15.2h-28z"
      />
      <path d="M488 802.9c2.7 0 5.5 6 5.5 14.9s-2.8 14.9-5.5 14.9h-28c-2.7 0-5.5-6-5.5-14.9s2.8-14.9 5.5-14.9h28m0-.5h-28c-3.3 0-6 6.9-6 15.4s2.7 15.4 6 15.4h28c3.3 0 6-6.9 6-15.4s-2.7-15.4-6-15.4z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M510 833c-3.1 0-5.8-6.9-5.8-15.2 0-8.2 2.6-15.2 5.8-15.2h28c3.1 0 5.8 6.9 5.8 15.2 0 8.2-2.6 15.2-5.8 15.2h-28z"
      />
      <path d="M538 802.9c2.7 0 5.5 6 5.5 14.9s-2.8 14.9-5.5 14.9h-28c-2.7 0-5.5-6-5.5-14.9s2.8-14.9 5.5-14.9h28m0-.5h-28c-3.3 0-6 6.9-6 15.4s2.7 15.4 6 15.4h28c3.3 0 6-6.9 6-15.4s-2.7-15.4-6-15.4z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M562 833c-3.1 0-5.8-6.9-5.8-15.2 0-8.2 2.6-15.2 5.8-15.2h28c3.1 0 5.8 6.9 5.8 15.2 0 8.2-2.6 15.2-5.8 15.2h-28z"
      />
      <path d="M590 802.9c2.7 0 5.5 6 5.5 14.9s-2.8 14.9-5.5 14.9h-28c-2.7 0-5.5-6-5.5-14.9s2.8-14.9 5.5-14.9h28m0-.5h-28c-3.3 0-6 6.9-6 15.4s2.7 15.4 6 15.4h28c3.3 0 6-6.9 6-15.4s-2.7-15.4-6-15.4z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M612 833c-2.9 0-5.4-6-5.7-13.6v-44.6c0-8.2 2.6-15.2 5.8-15.2h28c3.1 0 5.8 6.9 5.8 15.2v44.6c-.3 7.6-2.8 13.6-5.7 13.6H612z"
      />
      <path d="M640 759.7c2.7 0 5.5 6 5.5 14.9v44.6c-.3 7.4-2.7 13.4-5.5 13.4h-28c-2.7 0-5.2-6-5.5-13.4v-44.6c0-8.9 2.8-14.9 5.5-14.9h28m0-.5h-28c-3.3 0-6 6.9-6 15.4v44.6c.3 7.8 2.9 13.9 6 13.9h28c3.1 0 5.7-6.1 6-13.9v-44.6c0-8.5-2.7-15.4-6-15.4z" />
    </g>
    <g>
      <path className="mainprefix__st7" d="M606 817.8v1.5-1.5z" />
      <path d="M606 817.8v0z" />
    </g>
    <g>
      <path className="mainprefix__st7" d="M646 728v0z" />
      <path d="M646 728v1-1z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M460 869.9c-3.2 0-5.8-5.4-5.8-12.1 0-6.7 2.6-12.1 5.8-12.1h28c3.2 0 5.8 5.4 5.8 12.1 0 6.7-2.6 12.1-5.8 12.1h-28z"
      />
      <path d="M488 846c3 0 5.5 5.4 5.5 11.8s-2.5 11.8-5.5 11.8h-28c-3 0-5.5-5.4-5.5-11.8S457 846 460 846h28m0-.5h-28c-3.3 0-6 5.5-6 12.3 0 6.8 2.7 12.3 6 12.3h28c3.3 0 6-5.5 6-12.3 0-6.7-2.7-12.3-6-12.3z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M510 869.9c-3.2 0-5.8-5.4-5.8-12.1 0-6.7 2.6-12.1 5.8-12.1h28c3.2 0 5.8 5.4 5.8 12.1 0 6.7-2.6 12.1-5.8 12.1h-28z"
      />
      <path d="M538 846c3 0 5.5 5.4 5.5 11.8s-2.5 11.8-5.5 11.8h-28c-3 0-5.5-5.4-5.5-11.8S507 846 510 846h28m0-.5h-28c-3.3 0-6 5.5-6 12.3 0 6.8 2.7 12.3 6 12.3h28c3.3 0 6-5.5 6-12.3 0-6.7-2.7-12.3-6-12.3z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M562 869.9c-3.2 0-5.8-5.4-5.8-12.1 0-6.7 2.6-12.1 5.8-12.1h28c3.2 0 5.8 5.4 5.8 12.1 0 6.7-2.6 12.1-5.8 12.1h-28z"
      />
      <path d="M590 846c3 0 5.5 5.4 5.5 11.8s-2.5 11.8-5.5 11.8h-28c-3 0-5.5-5.4-5.5-11.8S559 846 562 846h28m0-.5h-28c-3.3 0-6 5.5-6 12.3 0 6.8 2.7 12.3 6 12.3h28c3.3 0 6-5.5 6-12.3 0-6.7-2.7-12.3-6-12.3z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M612 869.9c-3.2 0-5.8-5.4-5.8-12.1 0-6.7 2.6-12.1 5.8-12.1h28c3.2 0 5.8 5.4 5.8 12.1 0 6.7-2.6 12.1-5.8 12.1h-28z"
      />
      <path d="M640 846c3 0 5.5 5.4 5.5 11.8s-2.5 11.8-5.5 11.8h-28c-3 0-5.5-5.4-5.5-11.8S609 846 612 846h28m0-.5h-28c-3.3 0-6 5.5-6 12.3 0 6.8 2.7 12.3 6 12.3h28c3.3 0 6-5.5 6-12.3 0-6.7-2.7-12.3-6-12.3z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M460 903.8c-3.2 0-5.8-5.4-5.8-12.1s2.6-12.1 5.8-12.1h28c3.2 0 5.8 5.4 5.8 12.1s-2.6 12.1-5.8 12.1h-28z"
      />
      <path d="M488 879.9c3 0 5.5 5.4 5.5 11.8s-2.5 11.8-5.5 11.8h-28c-3 0-5.5-5.4-5.5-11.8s2.5-11.8 5.5-11.8h28m0-.5h-28c-3.3 0-6 5.5-6 12.3 0 6.8 2.7 12.3 6 12.3h28c3.3 0 6-5.5 6-12.3 0-6.7-2.7-12.3-6-12.3z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M510 903.8c-3.2 0-5.8-5.4-5.8-12.1s2.6-12.1 5.8-12.1h28c3.2 0 5.8 5.4 5.8 12.1s-2.6 12.1-5.8 12.1h-28z"
      />
      <path d="M538 879.9c3 0 5.5 5.4 5.5 11.8s-2.5 11.8-5.5 11.8h-28c-3 0-5.5-5.4-5.5-11.8s2.5-11.8 5.5-11.8h28m0-.5h-28c-3.3 0-6 5.5-6 12.3 0 6.8 2.7 12.3 6 12.3h28c3.3 0 6-5.5 6-12.3 0-6.7-2.7-12.3-6-12.3z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M562 903.8c-3.2 0-5.8-5.4-5.8-12.1s2.6-12.1 5.8-12.1h28c3.2 0 5.8 5.4 5.8 12.1s-2.6 12.1-5.8 12.1h-28z"
      />
      <path d="M590 879.9c3 0 5.5 5.4 5.5 11.8s-2.5 11.8-5.5 11.8h-28c-3 0-5.5-5.4-5.5-11.8s2.5-11.8 5.5-11.8h28m0-.5h-28c-3.3 0-6 5.5-6 12.3 0 6.8 2.7 12.3 6 12.3h28c3.3 0 6-5.5 6-12.3 0-6.7-2.7-12.3-6-12.3z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M612 903.8c-3.2 0-5.8-5.4-5.8-12.1s2.6-12.1 5.8-12.1h28c3.2 0 5.8 5.4 5.8 12.1s-2.6 12.1-5.8 12.1h-28z"
      />
      <path d="M640 879.9c3 0 5.5 5.4 5.5 11.8s-2.5 11.8-5.5 11.8h-28c-3 0-5.5-5.4-5.5-11.8s2.5-11.8 5.5-11.8h28m0-.5h-28c-3.3 0-6 5.5-6 12.3 0 6.8 2.7 12.3 6 12.3h28c3.3 0 6-5.5 6-12.3 0-6.7-2.7-12.3-6-12.3z" />
    </g>
    <g>
      <ellipse className="mainprefix__st10" cx={474} cy={925.7} rx={11.8} ry={9} />
      <path d="M474 916.9c6.3 0 11.5 3.9 11.5 8.7s-5.2 8.7-11.5 8.7-11.5-3.9-11.5-8.7 5.2-8.7 11.5-8.7m0-.5c-6.6 0-12 4.1-12 9.2s5.4 9.2 12 9.2 12-4.1 12-9.2-5.4-9.2-12-9.2z" />
    </g>
    <g>
      <ellipse className="mainprefix__st11" cx={626} cy={925.7} rx={12.8} ry={9} />
      <path d="M626 916.9c6.9 0 12.5 3.9 12.5 8.7s-5.6 8.7-12.5 8.7-12.5-3.9-12.5-8.7 5.6-8.7 12.5-8.7m0-.5c-7.2 0-13 4.1-13 9.2s5.8 9.2 13 9.2 13-4.1 13-9.2-5.8-9.2-13-9.2z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M510 937.8c-3.2 0-5.8-5.4-5.8-12.1 0-6.7 2.6-12.1 5.8-12.1h28c3.2 0 5.8 5.4 5.8 12.1 0 6.7-2.6 12.1-5.8 12.1h-28z"
      />
      <path d="M538 913.8c3 0 5.5 5.4 5.5 11.8s-2.5 11.8-5.5 11.8h-28c-3 0-5.5-5.4-5.5-11.8s2.5-11.8 5.5-11.8h28m0-.5h-28c-3.3 0-6 5.5-6 12.3 0 6.8 2.7 12.3 6 12.3h28c3.3 0 6-5.5 6-12.3 0-6.7-2.7-12.3-6-12.3z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M562 937.8c-3.2 0-5.8-5.4-5.8-12.1 0-6.7 2.6-12.1 5.8-12.1h28c3.2 0 5.8 5.4 5.8 12.1 0 6.7-2.6 12.1-5.8 12.1h-28z"
      />
      <path d="M590 913.8c3 0 5.5 5.4 5.5 11.8s-2.5 11.8-5.5 11.8h-28c-3 0-5.5-5.4-5.5-11.8s2.5-11.8 5.5-11.8h28m0-.5h-28c-3.3 0-6 5.5-6 12.3 0 6.8 2.7 12.3 6 12.3h28c3.3 0 6-5.5 6-12.3 0-6.7-2.7-12.3-6-12.3z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M460 703.5c-3.1 0-5.8-6.9-5.8-15.2 0-8.2 2.6-15.2 5.8-15.2h28c3.1 0 5.8 6.9 5.8 15.2 0 8.2-2.6 15.2-5.8 15.2h-28z"
      />
      <path d="M488 673.5c2.7 0 5.5 6 5.5 14.9s-2.8 14.9-5.5 14.9h-28c-2.7 0-5.5-6-5.5-14.9s2.8-14.9 5.5-14.9h28m0-.5h-28c-3.3 0-6 6.9-6 15.4s2.7 15.4 6 15.4h28c3.3 0 6-6.9 6-15.4s-2.7-15.4-6-15.4z" />
    </g>
    <g>
      <path d="M1131.8 759.1c-3.4 0-6.7-.6-8.9-1.7L882.6 637.2l239.6-119.8c2.1-1.1 5.4-1.7 8.8-1.7 3.4 0 6.7.6 8.9 1.7l240.3 120.2-239.6 119.8c-2.1 1-5.4 1.7-8.8 1.7z" />
      <path d="M1131.1 525.7c2.5 0 4 .5 4.4.7l222.4 111.2-221.7 110.9c-.4.2-1.9.6-4.3.6-2.5 0-4-.5-4.4-.7L905 637.2l221.7-110.9c.4-.1 1.9-.6 4.4-.6m0-20c-4.8 0-9.6.9-13.3 2.7L873.5 630.6c-7.3 3.7-7.3 9.6 0 13.3l244.9 122.4c3.7 1.8 8.5 2.8 13.3 2.8 4.8 0 9.6-.9 13.3-2.7l244.2-122.1c7.3-3.7 7.3-9.6 0-13.3l-244.9-122.4c-3.6-2-8.4-2.9-13.2-2.9zM1198.7 524.4l293.7-146.8 158.7 79.3-293.8 146.9z" />
      <path d="M1492.4 388.7l136.3 68.1-271.4 135.7-136.3-68.1 271.4-135.7m0-22.3l-316.1 158 181 90.5 316.1-158-181-90.5z" />
      <g>
        <path d="M1366.4 611.8l17.5-4.3-2.2 10.4z" />
        <path d="M1397 594l-63.4 15.6 55.5 21.9 7.9-37.5z" />
      </g>
      <g>
        <path d="M1168.4 519.2l17.9-.9-7.5 7.6z" />
        <path d="M1211.6 507l-75.1 3.9 43.8 27.7 31.3-31.6z" />
      </g>
    </g>
    <g>
      <path
        className="mainprefix__st0"
        d="M1131.8 704.1c-3.4 0-6.7-.6-8.9-1.7L882.6 582.2l239.6-119.8c2.1-1.1 5.4-1.7 8.8-1.7 3.4 0 6.7.6 8.9 1.7l240.3 120.2-239.6 119.8c-2.1 1-5.4 1.7-8.8 1.7z"
      />
      <path d="M1131.1 470.7c2.5 0 4 .5 4.4.7l222.4 111.2-221.7 110.9c-.4.2-1.9.6-4.3.6-2.5 0-4-.5-4.4-.7L905 582.2l221.7-110.9c.4-.1 1.9-.6 4.4-.6m0-20c-4.8 0-9.6.9-13.3 2.7L873.5 575.6c-7.3 3.7-7.3 9.6 0 13.3l244.9 122.4c3.7 1.8 8.5 2.8 13.3 2.8 4.8 0 9.6-.9 13.3-2.7l244.2-122.1c7.3-3.7 7.3-9.6 0-13.3l-244.9-122.4c-3.6-2-8.4-2.9-13.2-2.9z" />
      <path
        className="mainprefix__st1"
        d="M1198.7 469.4l293.7-146.8 158.7 79.3-293.8 146.9z"
      />
      <path d="M1492.4 333.7l136.3 68.1-271.4 135.7-136.3-68.1 271.4-135.7m0-22.3l-316.1 158 181 90.5 316.1-158-181-90.5z" />
      <g>
        <path className="mainprefix__st2" d="M1366.4 556.8l17.5-4.3-2.2 10.4z" />
        <path d="M1397 539l-63.4 15.6 55.5 21.9 7.9-37.5z" />
      </g>
      <g>
        <path className="mainprefix__st2" d="M1168.4 464.2l17.9-.9-7.5 7.6z" />
        <path d="M1211.6 452l-75.1 3.9 43.8 27.7 31.3-31.6z" />
      </g>
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M1361 531.8c-1 0-1.6-.2-1.8-.3l-19.8-9.9c-.2-.1-.2-.2-.2-.2 0-.9 2.1-3.2 6.9-5.5 4.3-2.2 9.3-3.6 12.4-3.6 1 0 1.6.2 1.8.3l19.8 9.9c.2.1.2.2.2.2 0 .9-2.1 3.2-6.9 5.5-4.3 2.1-9.3 3.6-12.4 3.6z"
      />
      <path
        className="mainprefix__st4"
        d="M1358.5 513.2c1 0 1.3.2 1.4.2l19.2 9.6c-.7.9-2.5 2.5-6.1 4.3-4.2 2.1-9 3.5-12 3.5-1 0-1.3-.2-1.4-.2l-19.2-9.6c.7-.9 2.5-2.5 6.1-4.3 4.2-2.1 9-3.5 12-3.5m0-2c-3.2 0-8.2 1.4-12.9 3.7-6 3-9 6.4-6.7 7.6l19.8 9.9c.5.3 1.3.4 2.3.4 3.2 0 8.2-1.4 12.9-3.7 6-3 9-6.4 6.7-7.6l-19.8-9.9c-.6-.3-1.4-.4-2.3-.4z"
      />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M1253.6 478c-1.1 0-1.6-.2-1.8-.3l-19.8-9.9c-.2-.1-.2-.2-.2-.2 0-.9 2.1-3.2 6.9-5.5 4.3-2.2 9.3-3.6 12.4-3.6 1.1 0 1.6.2 1.8.3l19.8 9.9c.2.1.2.2.2.2 0 .9-2.1 3.2-6.9 5.5-4.4 2.2-9.4 3.6-12.4 3.6z"
      />
      <path
        className="mainprefix__st5"
        d="M1251 459.4c1 0 1.3.2 1.4.2l19.2 9.6c-.7.9-2.5 2.5-6.1 4.3-4.2 2.1-9 3.5-12 3.5-1 0-1.3-.2-1.4-.2l-19.2-9.6c.7-.9 2.5-2.5 6.1-4.3 4.2-2.1 9-3.5 12-3.5m0-2c-3.2 0-8.2 1.4-12.9 3.7-6 3-9 6.4-6.7 7.6l19.8 9.9c.5.3 1.3.4 2.3.4 3.2 0 8.2-1.4 12.9-3.7 6-3 9-6.4 6.7-7.6l-19.8-9.9c-.6-.2-1.3-.4-2.3-.4z"
      />
    </g>
    <g>
      <path
        className="mainprefix__st6"
        d="M1277.7 480.9c6-3 14.7-3.5 19.4-1.2l39.6 19.8c4.7 2.3 3.6 6.7-2.4 9.7-6 3-14.7 3.5-19.4 1.2l-39.6-19.8c-4.7-2.3-3.6-6.6 2.4-9.7z"
      />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M1390.9 517.9c-1.1 0-2-.2-2.6-.5l-19.8-9.9c-.6-.3-.8-.7-.8-1.1 0-1.4 2.1-3.3 5.3-4.9 3.3-1.6 7.3-2.7 10.1-2.7 1.1 0 2 .2 2.6.5l19.8 9.9c.6.3.8.7.8 1.1 0 1.4-2.1 3.3-5.3 4.9-3.3 1.6-7.2 2.7-10.1 2.7z"
      />
      <path d="M1383.1 498.5v.5c1.1 0 1.9.2 2.5.4l19.8 9.9c.7.4.7.8.7.9 0 1-1.6 2.9-5.2 4.7-3.2 1.6-7.2 2.7-10 2.7-1.1 0-1.9-.2-2.5-.4l-19.8-9.9c-.7-.4-.7-.8-.7-.9 0-1 1.6-2.9 5.2-4.7 3.2-1.6 7.2-2.7 10-2.7v-.5m0 0c-2.8 0-6.8 1-10.2 2.7-4.8 2.4-6.8 5.3-4.5 6.5l19.8 9.9c.7.3 1.6.5 2.7.5 2.8 0 6.8-1 10.2-2.7 4.8-2.4 6.8-5.3 4.5-6.5l-19.8-9.9c-.6-.3-1.6-.5-2.7-.5z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M1355.5 500.2c-1.1 0-2-.2-2.6-.5l-19.8-9.9c-.6-.3-.8-.7-.8-1.1 0-1.4 2.1-3.3 5.3-4.9 3.3-1.6 7.3-2.7 10.1-2.7 1.1 0 2 .2 2.6.5l19.8 9.9c.6.3.8.7.8 1.1 0 1.4-2.1 3.3-5.3 4.9-3.2 1.6-7.2 2.7-10.1 2.7z"
      />
      <path d="M1347.7 480.9v.5c1.1 0 1.9.2 2.5.4l19.8 9.9c.7.4.7.8.7.9 0 1-1.6 2.9-5.2 4.7-3.2 1.6-7.2 2.7-10 2.7-1.1 0-1.9-.2-2.5-.4l-19.8-9.9c-.7-.4-.7-.8-.7-.9 0-1 1.6-2.9 5.2-4.7 3.2-1.6 7.2-2.7 10-2.7v-.5m0 0c-2.8 0-6.8 1-10.2 2.7-4.8 2.4-6.8 5.3-4.5 6.5l19.8 9.9c.7.3 1.6.5 2.7.5 2.8 0 6.8-1 10.2-2.7 4.8-2.4 6.8-5.3 4.5-6.5l-19.8-9.9c-.6-.4-1.5-.5-2.7-.5z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M1318.8 481.8c-1.1 0-2-.2-2.6-.5l-19.8-9.9c-.6-.3-.8-.7-.8-1.1 0-1.4 2.1-3.3 5.3-4.9 3.3-1.6 7.3-2.7 10.1-2.7 1.1 0 2 .2 2.6.5l19.8 9.9c.6.3.8.7.8 1.1 0 1.4-2.1 3.3-5.3 4.9-3.3 1.7-7.2 2.7-10.1 2.7z"
      />
      <path d="M1311 462.5v.5c1.1 0 1.9.2 2.5.4l19.8 9.9c.7.4.7.8.7.9 0 1-1.6 2.9-5.2 4.7-3.2 1.6-7.2 2.7-10 2.7-1.1 0-1.9-.2-2.5-.4l-19.8-9.9c-.7-.4-.7-.8-.7-.9 0-1 1.6-2.9 5.2-4.7 3.2-1.6 7.2-2.7 10-2.7v-.5m0 0c-2.8 0-6.8 1-10.2 2.7-4.8 2.4-6.8 5.3-4.5 6.5l19.8 9.9c.7.3 1.6.5 2.7.5 2.8 0 6.8-1 10.2-2.7 4.8-2.4 6.8-5.3 4.5-6.5l-19.8-9.9c-.7-.4-1.6-.5-2.7-.5z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M1283.4 464.1c-1.1 0-2-.2-2.6-.5l-19.8-9.9c-.6-.3-.8-.7-.8-1.1 0-1.4 2.1-3.3 5.3-4.9 3.3-1.6 7.3-2.7 10.1-2.7 1.1 0 2 .2 2.6.5l19.8 9.9c.6.3.8.7.8 1.1 0 1.4-2.1 3.3-5.3 4.9-3.2 1.7-7.2 2.7-10.1 2.7z"
      />
      <path d="M1275.6 445.3c1.1 0 1.9.2 2.5.4l19.8 9.9c.7.4.7.8.7.9 0 1-1.6 2.9-5.2 4.7-3.2 1.6-7.2 2.7-10 2.7-1.1 0-1.9-.2-2.5-.4l-19.8-9.9c-.7-.4-.7-.8-.7-.9 0-1 1.6-2.9 5.2-4.7 3.2-1.6 7.2-2.7 10-2.7m0-.5c-2.8 0-6.8 1-10.2 2.7-4.8 2.4-6.8 5.3-4.5 6.5l19.8 9.9c.7.3 1.6.5 2.7.5 2.8 0 6.8-1 10.2-2.7 4.8-2.4 6.8-5.3 4.5-6.5l-19.8-9.9c-.6-.3-1.6-.5-2.7-.5z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M1404.1 475.6c-.9 0-1.7-.1-2.2-.4l-19.8-9.9c-.4-.2-.7-.5-.7-.9 0-1.3 2.3-3.7 7.3-6.2 4.4-2.2 9.6-3.7 12.8-3.7.9 0 1.7.1 2.2.4l19.8 9.9c.4.2.7.5.7.9 0 1.3-2.3 3.7-7.3 6.2-4.4 2.2-9.6 3.7-12.8 3.7z"
      />
      <path d="M1401.6 454.8c.9 0 1.6.1 2.1.3l19.8 9.9c.5.2.5.5.5.7 0 1.2-2.2 3.5-7.2 6-4.4 2.2-9.5 3.7-12.6 3.7-.9 0-1.6-.1-2.1-.3l-19.8-9.9c-.5-.2-.5-.5-.5-.7 0-1.2 2.2-3.5 7.2-6 4.3-2.3 9.4-3.7 12.6-3.7m0-.5c-3.2 0-8.2 1.4-12.9 3.7-6 3-9 6.4-6.7 7.6l19.8 9.9c.5.3 1.3.4 2.3.4 3.2 0 8.2-1.4 12.9-3.7 6-3 9-6.4 6.7-7.6l-19.8-9.9c-.6-.3-1.4-.4-2.3-.4z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M1367.4 457.2c-.9 0-1.7-.1-2.2-.4l-19.8-9.9c-.4-.2-.7-.5-.7-.9 0-1.3 2.3-3.7 7.3-6.2 4.4-2.2 9.6-3.7 12.8-3.7.9 0 1.7.1 2.2.4l19.8 9.9c.4.2.7.5.7.9 0 1.3-2.3 3.7-7.3 6.2-4.5 2.2-9.6 3.7-12.8 3.7z"
      />
      <path d="M1364.8 436.4c.9 0 1.6.1 2.1.3l19.8 9.9c.5.2.5.5.5.7 0 1.2-2.2 3.5-7.2 6-4.4 2.2-9.5 3.7-12.6 3.7-.9 0-1.6-.1-2.1-.3l-19.8-9.9c-.5-.2-.5-.5-.5-.7 0-1.2 2.2-3.5 7.2-6 4.4-2.3 9.4-3.7 12.6-3.7m0-.5c-3.2 0-8.2 1.4-12.9 3.7-6 3-9 6.4-6.7 7.6l19.8 9.9c.5.3 1.3.4 2.3.4 3.2 0 8.2-1.4 12.9-3.7 6-3 9-6.4 6.7-7.6l-19.8-9.9c-.6-.3-1.3-.4-2.3-.4z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M1332 439.5c-.9 0-1.7-.1-2.2-.4l-19.8-9.9c-.4-.2-.7-.5-.7-.9 0-1.3 2.3-3.7 7.3-6.2 4.4-2.2 9.6-3.7 12.8-3.7.9 0 1.7.1 2.2.4l19.8 9.9c.4.2.7.5.7.9 0 1.3-2.3 3.7-7.3 6.2-4.5 2.3-9.6 3.7-12.8 3.7z"
      />
      <path d="M1329.5 418.7c.9 0 1.6.1 2.1.3l19.8 9.9c.5.2.5.5.5.7 0 1.2-2.2 3.5-7.2 6-4.4 2.2-9.5 3.7-12.6 3.7-.9 0-1.6-.1-2.1-.3l-19.8-9.9c-.5-.2-.5-.5-.5-.7 0-1.2 2.2-3.5 7.2-6 4.3-2.2 9.4-3.7 12.6-3.7m0-.5c-3.2 0-8.2 1.4-12.9 3.7-6 3-9 6.4-6.7 7.6l19.8 9.9c.5.3 1.3.4 2.3.4 3.2 0 8.2-1.4 12.9-3.7 6-3 9-6.4 6.7-7.6l-19.8-9.9c-.6-.3-1.4-.4-2.3-.4z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M1470 478c-.9 0-1.7-.1-2.2-.4l-19.8-9.9c-.4-.2-.7-.5-.7-.9 0-1.3 2.3-3.7 7.3-6.2 4.4-2.2 9.6-3.7 12.8-3.7.9 0 1.7.1 2.2.4l19.8 9.9c.4.2.7.5.7.9 0 1.3-2.3 3.7-7.3 6.2-4.5 2.2-9.6 3.7-12.8 3.7z"
      />
      <path d="M1467.4 457.2c.9 0 1.6.1 2.1.3l19.8 9.9c.5.2.5.5.5.7 0 1.2-2.2 3.5-7.2 6-4.4 2.2-9.5 3.7-12.6 3.7-.9 0-1.6-.1-2.1-.3l-19.8-9.9c-.5-.2-.5-.5-.5-.7 0-1.2 2.2-3.5 7.2-6 4.4-2.2 9.5-3.7 12.6-3.7m0-.5c-3.2 0-8.2 1.4-12.9 3.7-6 3-9 6.4-6.7 7.6l19.8 9.9c.5.3 1.3.4 2.3.4 3.2 0 8.2-1.4 12.9-3.7 6-3 9-6.4 6.7-7.6l-19.8-9.9c-.5-.3-1.3-.4-2.3-.4z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M1434.6 460.3c-.9 0-1.7-.1-2.2-.4l-19.8-9.9c-.4-.2-.7-.5-.7-.9 0-1.3 2.3-3.7 7.3-6.2 4.4-2.2 9.6-3.7 12.8-3.7.9 0 1.7.1 2.2.4l19.8 9.9c.4.2.7.5.7.9 0 1.3-2.3 3.7-7.3 6.2-4.4 2.3-9.6 3.7-12.8 3.7z"
      />
      <path d="M1432.1 439.5c.9 0 1.6.1 2.1.3l19.8 9.9c.5.2.5.5.5.7 0 1.2-2.2 3.5-7.2 6-4.4 2.2-9.5 3.7-12.6 3.7-.9 0-1.6-.1-2.1-.3l-19.8-9.9c-.5-.2-.5-.5-.5-.7 0-1.2 2.2-3.5 7.2-6 4.3-2.2 9.4-3.7 12.6-3.7m0-.5c-3.2 0-8.2 1.4-12.9 3.7-6 3-9 6.4-6.7 7.6l19.8 9.9c.5.3 1.3.4 2.3.4 3.2 0 8.2-1.4 12.9-3.7 6-3 9-6.4 6.7-7.6l-19.8-9.9c-.6-.3-1.4-.4-2.3-.4z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M1397.9 442c-.9 0-1.7-.1-2.2-.4l-19.8-9.9c-.4-.2-.7-.5-.7-.9 0-1.3 2.3-3.7 7.3-6.2 4.4-2.2 9.6-3.7 12.8-3.7.9 0 1.7.1 2.2.4l19.8 9.9c.4.2.7.5.7.9 0 1.3-2.3 3.7-7.3 6.2-4.5 2.2-9.6 3.7-12.8 3.7z"
      />
      <path d="M1395.3 421.1c.9 0 1.6.1 2.1.3l19.8 9.9c.5.2.5.5.5.7 0 1.2-2.2 3.5-7.2 6-4.4 2.2-9.5 3.7-12.6 3.7-.9 0-1.6-.1-2.1-.3l-19.8-9.9c-.5-.2-.5-.5-.5-.7 0-1.2 2.2-3.5 7.2-6 4.4-2.2 9.5-3.7 12.6-3.7m0-.5c-3.2 0-8.2 1.4-12.9 3.7-6 3-9 6.4-6.7 7.6l19.8 9.9c.5.3 1.3.4 2.3.4 3.2 0 8.2-1.4 12.9-3.7 6-3 9-6.4 6.7-7.6l-19.8-9.9c-.5-.3-1.3-.4-2.3-.4z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M1362.5 424.3c-.9 0-1.7-.1-2.2-.4l-19.8-9.9c-.4-.2-.7-.5-.7-.9 0-1.3 2.3-3.7 7.3-6.2 4.4-2.2 9.6-3.7 12.8-3.7.9 0 1.7.1 2.2.4l19.8 9.9c.4.2.7.5.7.9 0 1.3-2.3 3.7-7.3 6.2-4.5 2.2-9.6 3.7-12.8 3.7z"
      />
      <path d="M1360 403.4c.9 0 1.6.1 2.1.3l19.8 9.9c.5.2.5.5.5.7 0 1.2-2.2 3.5-7.2 6-4.4 2.2-9.5 3.7-12.6 3.7-.9 0-1.6-.1-2.1-.3l-19.8-9.9c-.5-.2-.5-.5-.5-.7 0-1.2 2.2-3.5 7.2-6 4.3-2.2 9.4-3.7 12.6-3.7m0-.5c-3.2 0-8.2 1.4-12.9 3.7-6 3-9 6.4-6.7 7.6l19.8 9.9c.5.3 1.3.4 2.3.4 3.2 0 8.2-1.4 12.9-3.7 6-3 9-6.4 6.7-7.6l-19.8-9.9c-.6-.2-1.4-.4-2.3-.4z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M1500.5 462.8c-.9 0-1.7-.1-2.2-.4l-19.8-9.9c-.4-.2-.7-.5-.7-.9 0-1.3 2.3-3.7 7.3-6.2 4.4-2.2 9.6-3.7 12.8-3.7.9 0 1.7.1 2.2.4l19.8 9.9c.4.2.7.5.7.9 0 1.3-2.3 3.7-7.3 6.2-4.5 2.2-9.6 3.7-12.8 3.7z"
      />
      <path d="M1498 441.9c.9 0 1.6.1 2.1.3l19.8 9.9c.5.2.5.5.5.7 0 1.2-2.2 3.5-7.2 6-4.4 2.2-9.5 3.7-12.6 3.7-.9 0-1.6-.1-2.1-.3l-19.8-9.9c-.5-.2-.5-.5-.5-.7 0-1.2 2.2-3.5 7.2-6 4.3-2.2 9.4-3.7 12.6-3.7m0-.5c-3.2 0-8.2 1.4-12.9 3.7-6 3-9 6.4-6.7 7.6l19.8 9.9c.5.3 1.3.4 2.3.4 3.2 0 8.2-1.4 12.9-3.7 6-3 9-6.4 6.7-7.6l-19.8-9.9c-.6-.2-1.4-.4-2.3-.4z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M1465.2 445.1c-.9 0-1.7-.1-2.2-.4l-19.8-9.9c-.4-.2-.7-.5-.7-.9 0-1.3 2.3-3.7 7.3-6.2 4.4-2.2 9.6-3.7 12.8-3.7.9 0 1.7.1 2.2.4l19.8 9.9c.4.2.7.5.7.9 0 1.3-2.3 3.7-7.3 6.2-4.5 2.2-9.6 3.7-12.8 3.7z"
      />
      <path d="M1462.6 424.2c.9 0 1.6.1 2.1.3l19.8 9.9c.5.2.5.5.5.7 0 1.2-2.2 3.5-7.2 6-4.4 2.2-9.5 3.7-12.6 3.7-.9 0-1.6-.1-2.1-.3l-19.8-9.9c-.5-.2-.5-.5-.5-.7 0-1.2 2.2-3.5 7.2-6 4.4-2.2 9.4-3.7 12.6-3.7m0-.5c-3.2 0-8.2 1.4-12.9 3.7-6 3-9 6.4-6.7 7.6l19.8 9.9c.5.3 1.3.4 2.3.4 3.2 0 8.2-1.4 12.9-3.7 6-3 9-6.4 6.7-7.6l-19.8-9.9c-.6-.2-1.3-.4-2.3-.4z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M1428.4 426.7c-.9 0-1.7-.1-2.2-.4l-19.8-9.9c-.4-.2-.7-.5-.7-.9 0-1.3 2.3-3.7 7.3-6.2 4.4-2.2 9.6-3.7 12.8-3.7.9 0 1.7.1 2.2.4l19.8 9.9c.4.2.7.5.7.9 0 1.3-2.3 3.7-7.3 6.2-4.5 2.2-9.6 3.7-12.8 3.7z"
      />
      <path d="M1425.8 405.9c.9 0 1.6.1 2.1.3l19.8 9.9c.5.2.5.5.5.7 0 1.2-2.2 3.5-7.2 6-4.4 2.2-9.5 3.7-12.6 3.7-.9 0-1.6-.1-2.1-.3l-19.8-9.9c-.5-.2-.5-.5-.5-.7 0-1.2 2.2-3.5 7.2-6 4.4-2.3 9.5-3.7 12.6-3.7m0-.5c-3.2 0-8.2 1.4-12.9 3.7-6 3-9 6.4-6.7 7.6l19.8 9.9c.5.3 1.3.4 2.3.4 3.2 0 8.2-1.4 12.9-3.7 6-3 9-6.4 6.7-7.6l-19.8-9.9c-.5-.3-1.3-.4-2.3-.4z" />
    </g>
    <g>
      <path
        className="mainprefix__st8"
        d="M1414.9 505.9c-1.1 0-2-.2-2.6-.5l-19.8-9.9c-.6-.3-.8-.7-.8-1.1 0-1.4 2.1-3.3 5.3-4.9 3.3-1.6 7.3-2.7 10.1-2.7 1.1 0 2 .2 2.6.5l19.8 9.9c.6.3.8.7.8 1.1 0 1.4-2.1 3.3-5.3 4.9-3.3 1.6-7.3 2.7-10.1 2.7z"
      />
      <path d="M1407.1 486.6v.5c1.1 0 1.9.2 2.5.4l19.8 9.9c.7.4.7.8.7.9 0 1-1.6 2.9-5.2 4.7-3.2 1.6-7.2 2.7-10 2.7-1.1 0-1.9-.2-2.5-.4l-19.8-9.9c-.7-.4-.7-.8-.7-.9 0-1 1.6-2.9 5.2-4.7 3.2-1.6 7.2-2.7 10-2.7v-.5m0 0c-2.8 0-6.8 1-10.2 2.7-4.8 2.4-6.8 5.3-4.5 6.5l19.8 9.9c.7.3 1.6.5 2.7.5 2.8 0 6.8-1 10.2-2.7 4.8-2.4 6.8-5.3 4.5-6.5l-19.8-9.9c-.7-.4-1.6-.5-2.7-.5z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M1379.5 488.2c-1.1 0-2-.2-2.6-.5l-19.8-9.9c-.6-.3-.8-.7-.8-1.1 0-1.4 2.1-3.3 5.3-4.9 3.3-1.6 7.3-2.7 10.1-2.7 1.1 0 2 .2 2.6.5l19.8 9.9c.6.3.8.7.8 1.1 0 1.4-2.1 3.3-5.3 4.9-3.2 1.7-7.2 2.7-10.1 2.7z"
      />
      <path d="M1371.7 468.9v.5c1.1 0 1.9.2 2.5.4l19.8 9.9c.7.4.7.8.7.9 0 1-1.6 2.9-5.2 4.7-3.2 1.6-7.2 2.7-10 2.7-1.1 0-1.9-.2-2.5-.4l-19.8-9.9c-.7-.4-.7-.8-.7-.9 0-1 1.6-2.9 5.2-4.7 3.2-1.6 7.2-2.7 10-2.7v-.5m0 0c-2.8 0-6.8 1-10.2 2.7-4.8 2.4-6.8 5.3-4.5 6.5l19.8 9.9c.7.3 1.6.5 2.7.5 2.8 0 6.8-1 10.2-2.7 4.8-2.4 6.8-5.3 4.5-6.5l-19.8-9.9c-.6-.4-1.6-.5-2.7-.5z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M1342.8 469.8c-1.1 0-2-.2-2.6-.5l-19.8-9.9c-.6-.3-.8-.7-.8-1.1 0-1.4 2.1-3.3 5.3-4.9 3.3-1.6 7.3-2.7 10.1-2.7 1.1 0 2 .2 2.6.5l19.8 9.9c.6.3.8.7.8 1.1 0 1.4-2.1 3.3-5.3 4.9-3.3 1.7-7.3 2.7-10.1 2.7z"
      />
      <path d="M1334.9 450.5v.5c1.1 0 1.9.2 2.5.4l19.8 9.9c.7.4.7.8.7.9 0 1-1.6 2.9-5.2 4.7-3.2 1.6-7.2 2.7-10 2.7-1.1 0-1.9-.2-2.5-.4l-19.8-9.9c-.7-.4-.7-.8-.7-.9 0-1 1.6-2.9 5.2-4.7 3.2-1.6 7.2-2.7 10-2.7v-.5m0 0c-2.8 0-6.8 1-10.2 2.7-4.8 2.4-6.8 5.3-4.5 6.5l19.8 9.9c.7.3 1.6.5 2.7.5 2.8 0 6.8-1 10.2-2.7 4.8-2.4 6.8-5.3 4.5-6.5l-19.8-9.9c-.6-.4-1.5-.5-2.7-.5z" />
    </g>
    <g>
      <path
        className="mainprefix__st9"
        d="M1307.4 452.2c-1.1 0-2-.2-2.6-.5l-19.8-9.9c-.6-.3-.8-.7-.8-1.1 0-1.4 2.1-3.3 5.3-4.9 3.3-1.6 7.3-2.7 10.1-2.7 1.1 0 2 .2 2.6.5l19.8 9.9c.6.3.8.7.8 1.1 0 1.4-2.1 3.3-5.3 4.9-3.3 1.6-7.2 2.7-10.1 2.7z"
      />
      <path d="M1299.6 432.8v.5c1.1 0 1.9.2 2.5.4l19.8 9.9c.7.4.7.8.7.9 0 1-1.6 2.9-5.2 4.7-3.2 1.6-7.2 2.7-10 2.7-1.1 0-1.9-.2-2.5-.4l-19.8-9.9c-.7-.4-.7-.8-.7-.9 0-1 1.6-2.9 5.2-4.7 3.2-1.6 7.2-2.7 10-2.7v-.5m0 0c-2.8 0-6.8 1-10.2 2.7-4.8 2.4-6.8 5.3-4.5 6.5l19.8 9.9c.7.3 1.6.5 2.7.5 2.8 0 6.8-1 10.2-2.7 4.8-2.4 6.8-5.3 4.5-6.5l-19.8-9.9c-.7-.3-1.6-.5-2.7-.5z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M1531 447.5c-.9 0-1.7-.1-2.2-.4l-19.8-9.9c-.4-.2-.7-.5-.7-.9 0-1.3 2.3-3.7 7.3-6.2 4.4-2.2 9.5-3.7 12.8-3.7.9 0 1.7.1 2.2.4l19.8 9.9c.4.2.7.5.7.9 0 1.3-2.3 3.7-7.3 6.2-4.5 2.2-9.6 3.7-12.8 3.7z"
      />
      <path d="M1528.5 426.7c.9 0 1.6.1 2.1.3l19.8 9.9c.5.2.5.5.5.7 0 1.2-2.2 3.5-7.2 6-4.4 2.2-9.5 3.7-12.6 3.7-.9 0-1.6-.1-2.1-.3l-19.8-9.9c-.5-.2-.5-.5-.5-.7 0-1.2 2.2-3.5 7.2-6 4.3-2.3 9.4-3.7 12.6-3.7m0-.5c-3.2 0-8.2 1.4-12.9 3.7-6 3-9 6.4-6.7 7.6l19.8 9.9c.5.3 1.3.4 2.3.4 3.2 0 8.2-1.4 12.9-3.7 6-3 9-6.4 6.7-7.6l-19.8-9.9c-.6-.3-1.4-.4-2.3-.4z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M1495.7 429.8c-.9 0-1.7-.1-2.2-.4l-19.8-9.9c-.4-.2-.7-.5-.7-.9 0-1.3 2.3-3.7 7.3-6.2 4.4-2.2 9.6-3.7 12.8-3.7.9 0 1.7.1 2.2.4l19.8 9.9c.4.2.7.5.7.9 0 1.3-2.3 3.7-7.3 6.2-4.5 2.3-9.6 3.7-12.8 3.7z"
      />
      <path d="M1493.1 409c.9 0 1.6.1 2.1.3l19.8 9.9c.5.2.5.5.5.7 0 1.2-2.2 3.5-7.2 6-4.4 2.2-9.5 3.7-12.6 3.7-.9 0-1.6-.1-2.1-.3l-19.8-9.9c-.5-.2-.5-.5-.5-.7 0-1.2 2.2-3.5 7.2-6 4.4-2.2 9.4-3.7 12.6-3.7m0-.5c-3.2 0-8.2 1.4-12.9 3.7-6 3-9 6.4-6.7 7.6l19.8 9.9c.5.3 1.3.4 2.3.4 3.2 0 8.2-1.4 12.9-3.7 6-3 9-6.4 6.7-7.6l-19.8-9.9c-.6-.3-1.3-.4-2.3-.4z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M1458.9 411.5c-.9 0-1.7-.1-2.2-.4l-19.8-9.9c-.4-.2-.7-.5-.7-.9 0-1.3 2.3-3.7 7.3-6.2 4.4-2.2 9.6-3.7 12.8-3.7.9 0 1.7.1 2.2.4l19.8 9.9c.4.2.7.5.7.9 0 1.3-2.3 3.7-7.3 6.2-4.5 2.2-9.6 3.7-12.8 3.7z"
      />
      <path d="M1456.3 390.6c.9 0 1.6.1 2.1.3l19.8 9.9c.5.2.5.5.5.7 0 1.2-2.2 3.5-7.2 6-4.4 2.2-9.5 3.7-12.6 3.7-.9 0-1.6-.1-2.1-.3L1437 401c-.5-.2-.5-.5-.5-.7 0-1.2 2.2-3.5 7.2-6 4.4-2.2 9.5-3.7 12.6-3.7m0-.5c-3.2 0-8.2 1.4-12.9 3.7-6 3-9 6.4-6.7 7.6l19.8 9.9c.5.3 1.3.4 2.3.4 3.2 0 8.2-1.4 12.9-3.7 6-3 9-6.4 6.7-7.6l-19.8-9.9c-.5-.3-1.3-.4-2.3-.4z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M1393 409c-.9 0-1.7-.1-2.2-.4l-19.8-9.9c-.4-.2-.7-.5-.7-.9 0-1.3 2.3-3.7 7.3-6.2l30.5-15.3c.4-.2.7-.4 1.1-.5 4.2-1.9 8.7-3.2 11.6-3.2.9 0 1.7.1 2.2.4l19.8 9.9c.4.2.7.5.7.9 0 1.4-2.4 3.6-6.3 5.7-.3.2-.7.4-1.1.6l-30.5 15.3c-4.2 2.1-9.4 3.6-12.6 3.6z"
      />
      <path d="M1421 372.4v.5c.9 0 1.6.1 2.1.3l19.8 9.9c.5.2.5.5.5.7 0 1-1.9 3.2-6.1 5.4-.3.2-.7.4-1.1.5l-30.5 15.3c-4.4 2.2-9.5 3.7-12.6 3.7-.9 0-1.6-.1-2.1-.3l-19.8-9.9c-.5-.2-.5-.5-.5-.7 0-1.2 2.2-3.5 7.2-6l30.5-15.3c.4-.2.7-.4 1.1-.5 4.1-1.9 8.7-3.1 11.5-3.1v-.5m0 0c-2.9 0-7.4 1.2-11.8 3.2-.4.2-.7.3-1.1.5l-30.5 15.3c-6 3-9 6.4-6.7 7.6l19.8 9.9c.5.3 1.3.4 2.3.4 3.2 0 8.2-1.4 12.9-3.7l30.5-15.3c.4-.2.7-.4 1.1-.6 5.3-2.9 7.8-5.9 5.6-7l-19.8-9.9c-.6-.2-1.4-.4-2.3-.4z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M1436.4 390.3c.4-.2.7-.4 1.1-.6l-1.1.6z"
      />
      <path d="M1437.5 389.7c-.3.2-.7.4-1.1.6l1.1-.6z" />
    </g>
    <g>
      <path className="mainprefix__st7" d="M1344.6 407.9l.7-.4c-.2.2-.4.3-.7.4z" />
      <path d="M1345.3 407.6l-.7.4c.3-.2.5-.3.7-.4z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M1562 432.3c-1.1 0-2-.2-2.6-.5l-19.8-9.9c-.6-.3-.8-.7-.8-1.1 0-1.4 2.1-3.3 5.3-4.9 3.3-1.6 7.3-2.7 10.1-2.7 1.1 0 2 .2 2.6.5l19.8 9.9c.6.3.8.7.8 1.1 0 1.4-2.1 3.3-5.3 4.9-3.3 1.7-7.3 2.7-10.1 2.7z"
      />
      <path d="M1554.2 413.5c1.1 0 1.9.2 2.5.4l19.8 9.9c.7.4.7.8.7.9 0 1-1.6 2.9-5.2 4.7-3.2 1.6-7.2 2.7-10 2.7-1.1 0-1.9-.2-2.5-.4l-19.8-9.9c-.7-.4-.7-.8-.7-.9 0-1 1.6-2.9 5.2-4.7 3.2-1.6 7.1-2.7 10-2.7m0-.5c-2.8 0-6.8 1-10.2 2.7-4.8 2.4-6.8 5.3-4.5 6.5l19.8 9.9c.7.3 1.6.5 2.7.5 2.8 0 6.8-1 10.2-2.7 4.8-2.4 6.8-5.3 4.5-6.5l-19.8-9.9c-.7-.3-1.6-.5-2.7-.5z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M1526.6 414.7c-1.1 0-2-.2-2.6-.5l-19.8-9.9c-.6-.3-.8-.7-.8-1.1 0-1.4 2.1-3.3 5.3-4.9 3.3-1.6 7.3-2.7 10.1-2.7 1.1 0 2 .2 2.6.5l19.8 9.9c.6.3.8.7.8 1.1 0 1.4-2.1 3.3-5.3 4.9-3.2 1.6-7.2 2.7-10.1 2.7z"
      />
      <path d="M1518.8 395.8c1.1 0 1.9.2 2.5.4l19.8 9.9c.7.4.7.8.7.9 0 1-1.6 2.9-5.2 4.7-3.2 1.6-7.2 2.7-10 2.7-1.1 0-1.9-.2-2.5-.4l-19.8-9.9c-.7-.4-.7-.8-.7-.9 0-1 1.6-2.9 5.2-4.7 3.2-1.6 7.2-2.7 10-2.7m0-.5c-2.8 0-6.8 1-10.2 2.7-4.8 2.4-6.8 5.3-4.5 6.5l19.8 9.9c.7.3 1.6.5 2.7.5 2.8 0 6.8-1 10.2-2.7 4.8-2.4 6.8-5.3 4.5-6.5l-19.8-9.9c-.6-.3-1.6-.5-2.7-.5z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M1489.9 396.3c-1.1 0-2-.2-2.6-.5l-19.8-9.9c-.6-.3-.8-.7-.8-1.1 0-1.4 2.1-3.3 5.3-4.9 3.3-1.6 7.3-2.7 10.1-2.7 1.1 0 2 .2 2.6.5l19.8 9.9c.6.3.8.7.8 1.1 0 1.4-2.1 3.3-5.3 4.9-3.3 1.6-7.3 2.7-10.1 2.7z"
      />
      <path d="M1482 377.4c1.1 0 1.9.2 2.5.4l19.8 9.9c.7.4.7.8.7.9 0 1-1.6 2.9-5.2 4.7-3.2 1.6-7.2 2.7-10 2.7-1.1 0-1.9-.2-2.5-.4l-19.8-9.9c-.7-.4-.7-.8-.7-.9 0-1 1.6-2.9 5.2-4.7 3.3-1.6 7.2-2.7 10-2.7m0-.5c-2.8 0-6.8 1-10.2 2.7-4.8 2.4-6.8 5.3-4.5 6.5l19.8 9.9c.7.3 1.6.5 2.7.5 2.8 0 6.8-1 10.2-2.7 4.8-2.4 6.8-5.3 4.5-6.5l-19.8-9.9c-.6-.3-1.5-.5-2.7-.5z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M1454.5 378.6c-1.1 0-2-.2-2.6-.5l-19.8-9.9c-.6-.3-.8-.7-.8-1.1 0-1.4 2.1-3.3 5.3-4.9 3.3-1.6 7.3-2.7 10.1-2.7 1.1 0 2 .2 2.6.5l19.8 9.9c.6.3.8.7.8 1.1 0 1.4-2.1 3.3-5.3 4.9-3.3 1.6-7.2 2.7-10.1 2.7z"
      />
      <path d="M1446.7 359.8c1.1 0 1.9.2 2.5.4l19.8 9.9c.7.4.7.8.7.9 0 1-1.6 2.9-5.2 4.7-3.2 1.6-7.2 2.7-10 2.7-1.1 0-1.9-.2-2.5-.4l-19.8-9.9c-.7-.4-.7-.8-.7-.9 0-1 1.6-2.9 5.2-4.7 3.2-1.7 7.1-2.7 10-2.7m0-.5c-2.8 0-6.8 1-10.2 2.7-4.8 2.4-6.8 5.3-4.5 6.5l19.8 9.9c.7.3 1.6.5 2.7.5 2.8 0 6.8-1 10.2-2.7 4.8-2.4 6.8-5.3 4.5-6.5l-19.8-9.9c-.7-.4-1.6-.5-2.7-.5z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M1586 420.4c-1.1 0-2-.2-2.6-.5l-19.8-9.9c-.6-.3-.8-.7-.8-1.1 0-1.4 2.1-3.3 5.3-4.9 3.3-1.6 7.3-2.7 10.1-2.7 1.1 0 2 .2 2.6.5l19.8 9.9c.6.3.8.7.8 1.1 0 1.4-2.1 3.3-5.3 4.9-3.3 1.6-7.3 2.7-10.1 2.7z"
      />
      <path d="M1578.1 401.5c1.1 0 1.9.2 2.5.4l19.8 9.9c.7.4.7.8.7.9 0 1-1.6 2.9-5.2 4.7-3.2 1.6-7.2 2.7-10 2.7-1.1 0-1.9-.2-2.5-.4l-19.8-9.9c-.7-.4-.7-.8-.7-.9 0-1 1.6-2.9 5.2-4.7 3.3-1.6 7.2-2.7 10-2.7m0-.5c-2.8 0-6.8 1-10.2 2.7-4.8 2.4-6.8 5.3-4.5 6.5l19.8 9.9c.7.3 1.6.5 2.7.5 2.8 0 6.8-1 10.2-2.7 4.8-2.4 6.8-5.3 4.5-6.5l-19.8-9.9c-.6-.3-1.5-.5-2.7-.5z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M1550.6 402.7c-1.1 0-2-.2-2.6-.5l-19.8-9.9c-.6-.3-.8-.7-.8-1.1 0-1.4 2.1-3.3 5.3-4.9 3.3-1.6 7.3-2.7 10.1-2.7 1.1 0 2 .2 2.6.5l19.8 9.9c.6.3.8.7.8 1.1 0 1.4-2.1 3.3-5.3 4.9-3.3 1.6-7.2 2.7-10.1 2.7z"
      />
      <path d="M1542.8 383.3v.5c1.1 0 1.9.2 2.5.4l19.8 9.9c.7.4.7.8.7.9 0 1-1.6 2.9-5.2 4.7-3.2 1.6-7.2 2.7-10 2.7-1.1 0-1.9-.2-2.5-.4l-19.8-9.9c-.7-.4-.7-.8-.7-.9 0-1 1.6-2.9 5.2-4.7 3.2-1.6 7.2-2.7 10-2.7v-.5m0 0c-2.8 0-6.8 1-10.2 2.7-4.8 2.4-6.8 5.3-4.5 6.5l19.8 9.9c.7.3 1.6.5 2.7.5 2.8 0 6.8-1 10.2-2.7 4.8-2.4 6.8-5.3 4.5-6.5l-19.8-9.9c-.7-.3-1.6-.5-2.7-.5z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M1513.8 384.3c-1.1 0-2-.2-2.6-.5l-19.8-9.9c-.6-.3-.8-.7-.8-1.1 0-1.4 2.1-3.3 5.3-4.9 3.3-1.6 7.3-2.7 10.1-2.7 1.1 0 2 .2 2.6.5l19.8 9.9c.6.3.8.7.8 1.1 0 1.4-2.1 3.3-5.3 4.9-3.2 1.6-7.2 2.7-10.1 2.7z"
      />
      <path d="M1506 365v.5c1.1 0 1.9.2 2.5.4l19.8 9.9c.7.4.7.8.7.9 0 1-1.6 2.9-5.2 4.7-3.2 1.6-7.2 2.7-10 2.7-1.1 0-1.9-.2-2.5-.4l-19.8-9.9c-.7-.4-.7-.8-.7-.9 0-1 1.6-2.9 5.2-4.7 3.2-1.6 7.2-2.7 10-2.7v-.5m0 0c-2.8 0-6.8 1-10.2 2.7-4.8 2.4-6.8 5.3-4.5 6.5l19.8 9.9c.7.3 1.6.5 2.7.5 2.8 0 6.8-1 10.2-2.7 4.8-2.4 6.8-5.3 4.5-6.5l-19.8-9.9c-.6-.4-1.6-.5-2.7-.5z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M1478.5 366.6c-1.1 0-2-.2-2.6-.5l-19.8-9.9c-.6-.3-.8-.7-.8-1.1 0-1.4 2.1-3.3 5.3-4.9 3.3-1.6 7.3-2.7 10.1-2.7 1.1 0 2 .2 2.6.5l19.8 9.9c.6.3.8.7.8 1.1 0 1.4-2.1 3.3-5.3 4.9-3.3 1.7-7.3 2.7-10.1 2.7z"
      />
      <path d="M1470.7 347.8c1.1 0 1.9.2 2.5.4l19.8 9.9c.7.4.7.8.7.9 0 1-1.6 2.9-5.2 4.7-3.2 1.6-7.2 2.7-10 2.7-1.1 0-1.9-.2-2.5-.4l-19.8-9.9c-.7-.4-.7-.8-.7-.9 0-1 1.6-2.9 5.2-4.7 3.2-1.7 7.1-2.7 10-2.7m0-.5c-2.8 0-6.8 1-10.2 2.7-4.8 2.4-6.8 5.3-4.5 6.5l19.8 9.9c.7.3 1.6.5 2.7.5 2.8 0 6.8-1 10.2-2.7 4.8-2.4 6.8-5.3 4.5-6.5l-19.8-9.9c-.7-.4-1.6-.5-2.7-.5z" />
    </g>
    <g>
      <path
        className="mainprefix__st10"
        d="M1608.8 403.9c-3.2 0-6.5-.8-9.2-2.1-2.5-1.3-4-2.9-4-4.4 0-1.1.7-2 2.1-2.6 1.4-.7 3.4-1.1 5.6-1.1 3.2 0 6.5.8 9.2 2.1 2.5 1.3 4 2.9 4 4.4 0 1.1-.7 2-2.1 2.6-1.4.8-3.4 1.1-5.6 1.1z"
      />
      <path d="M1603.3 394c3.2 0 6.5.7 9.1 2 2.4 1.2 3.9 2.8 3.9 4.2 0 1.2-1.1 2-2 2.4-1.4.7-3.3 1.1-5.5 1.1-3.2 0-6.5-.7-9.1-2-2.4-1.2-3.9-2.8-3.9-4.2 0-1.2 1.1-2 2-2.4 1.3-.7 3.3-1.1 5.5-1.1m0-.5c-2.2 0-4.2.4-5.7 1.1-3.6 1.8-2.7 5.2 1.9 7.5 2.7 1.4 6.2 2.1 9.3 2.1 2.2 0 4.2-.4 5.7-1.1 3.6-1.8 2.7-5.2-1.9-7.5-2.8-1.4-6.2-2.1-9.3-2.1z" />
    </g>
    <g>
      <path
        className="mainprefix__st11"
        d="M1502.2 350.5c-3.4 0-7.2-.9-10.1-2.3-2.9-1.4-4.6-3.3-4.6-4.9 0-1 .7-1.9 2-2.5 1.3-.7 3.2-1 5.4-1 3.4 0 7.2.9 10.1 2.3 2.9 1.4 4.6 3.3 4.6 4.9 0 1-.7 1.9-2 2.5-1.3.6-3.2 1-5.4 1z"
      />
      <path d="M1494.8 339.9c3.4 0 7.1.9 10 2.3 2.8 1.4 4.5 3.1 4.5 4.7 0 1.1-1 1.9-1.8 2.3-1.3.6-3.1 1-5.3 1-3.4 0-7.1-.9-10-2.3-2.8-1.4-4.5-3.1-4.5-4.7 0-1.1 1-1.9 1.8-2.3 1.4-.6 3.2-1 5.3-1m0-.5c-2.1 0-4.1.3-5.5 1-3.6 1.8-2.4 5.3 2.7 7.9 3.1 1.5 6.9 2.4 10.2 2.4 2.1 0 4.1-.3 5.5-1 3.6-1.8 2.4-5.3-2.7-7.9-3-1.5-6.8-2.4-10.2-2.4z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M1574.6 390.7c-1.1 0-2-.2-2.6-.5l-19.8-9.9c-.6-.3-.8-.7-.8-1.1 0-1.4 2.1-3.3 5.3-4.9 3.3-1.6 7.3-2.7 10.1-2.7 1.1 0 2 .2 2.6.5l19.8 9.9c.6.3.8.7.8 1.1 0 1.4-2.1 3.3-5.3 4.9-3.3 1.6-7.3 2.7-10.1 2.7z"
      />
      <path d="M1566.8 371.4v.5c1.1 0 1.9.2 2.5.4l19.8 9.9c.7.4.7.8.7.9 0 1-1.6 2.9-5.2 4.7-3.2 1.6-7.2 2.7-10 2.7-1.1 0-1.9-.2-2.5-.4l-19.8-9.9c-.7-.4-.7-.8-.7-.9 0-1 1.6-2.9 5.2-4.7 3.2-1.6 7.2-2.7 10-2.7v-.5m0 0c-2.8 0-6.8 1-10.2 2.7-4.8 2.4-6.8 5.3-4.5 6.5l19.8 9.9c.7.3 1.6.5 2.7.5 2.8 0 6.8-1 10.2-2.7 4.8-2.4 6.8-5.3 4.5-6.5l-19.8-9.9c-.7-.4-1.6-.5-2.7-.5z" />
    </g>
    <g>
      <path
        className="mainprefix__st3"
        d="M1537.8 372.3c-1.1 0-2-.2-2.6-.5l-19.8-9.9c-.6-.3-.8-.7-.8-1.1 0-1.4 2.1-3.3 5.3-4.9 3.3-1.6 7.3-2.7 10.1-2.7 1.1 0 2 .2 2.6.5l19.8 9.9c.6.3.8.7.8 1.1 0 1.4-2.1 3.3-5.3 4.9-3.3 1.7-7.2 2.7-10.1 2.7z"
      />
      <path d="M1530 353.5c1.1 0 1.9.2 2.5.4l19.8 9.9c.7.4.7.8.7.9 0 1-1.6 2.9-5.2 4.7-3.2 1.6-7.2 2.7-10 2.7-1.1 0-1.9-.2-2.5-.4l-19.8-9.9c-.7-.4-.7-.8-.7-.9 0-1 1.6-2.9 5.2-4.7 3.2-1.7 7.1-2.7 10-2.7m0-.5c-2.8 0-6.8 1-10.2 2.7-4.8 2.4-6.8 5.3-4.5 6.5l19.8 9.9c.7.3 1.6.5 2.7.5 2.8 0 6.8-1 10.2-2.7 4.8-2.4 6.8-5.3 4.5-6.5l-19.8-9.9c-.7-.4-1.6-.5-2.7-.5z" />
    </g>
    <g>
      <path
        className="mainprefix__st7"
        d="M1439.5 493.3c-.9 0-1.7-.1-2.2-.4l-19.8-9.9c-.4-.2-.7-.5-.7-.9 0-1.3 2.3-3.7 7.3-6.2 4.4-2.2 9.6-3.7 12.8-3.7.9 0 1.7.1 2.2.4l19.8 9.9c.4.2.7.5.7.9 0 1.3-2.3 3.7-7.3 6.2-4.5 2.2-9.6 3.7-12.8 3.7z"
      />
      <path d="M1436.9 472.4c.9 0 1.6.1 2.1.3l19.8 9.9c.5.2.5.5.5.7 0 1.2-2.2 3.5-7.2 6-4.4 2.2-9.5 3.7-12.6 3.7-.9 0-1.6-.1-2.1-.3l-19.8-9.9c-.5-.2-.5-.5-.5-.7 0-1.2 2.2-3.5 7.2-6 4.4-2.2 9.5-3.7 12.6-3.7m0-.5c-3.2 0-8.2 1.4-12.9 3.7-6 3-9 6.4-6.7 7.6l19.8 9.9c.5.3 1.3.4 2.3.4 3.2 0 8.2-1.4 12.9-3.7 6-3 9-6.4 6.7-7.6l-19.8-9.9c-.5-.2-1.3-.4-2.3-.4z" />
    </g>
    <path d="M868 582.4v55l263.4 131.7v-55z" />
    <path d="M1394.8 637.4v-55L1131 714v55zM1395 637l2-43v-55l-2 43s.3 54.7 0 55zM1673 457v-56l-276 138v55z" />
    <path className="mainprefix__st11" d="M926.7 611.7l-1.4 54.3 121.4 60.7v-55z" />
  </svg>
)

export default Scaner
